module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 23.5l-6.744 3.546a.5.5 0 01-.726-.527l1.288-7.51-5.456-5.32a.5.5 0 01.277-.852l7.54-1.096 3.373-6.833a.5.5 0 01.896 0l3.373 6.833 7.54 1.096a.5.5 0 01.277.853l-5.456 5.319 1.288 7.51a.5.5 0 01-.726.527z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/system/asda-star-filled.svg
// module id = 723
// module chunks = 0